import { Stack } from "@mui/material";
import { useMemo } from "react";
import { GridViewIcon, TableViewIcon } from "../images";
import { ColumnType } from "../../types/enums";

export const TableTabs = ({
  isGrid,
  setColumnsType,
}: {
  isGrid: boolean;
  setColumnsType: (type: ColumnType) => void;
}) => {
  const tabs = useMemo(
    () => [
      {
        icon: <GridViewIcon color={isGrid ? "#1C3C6C" : "#BCBCBC"} />,
        selected: isGrid,
        type: ColumnType.grid,
      },
      {
        icon: <TableViewIcon color={!isGrid ? "#1C3C6C" : "#BCBCBC"} />,
        selected: !isGrid,
        type: ColumnType.row,
      },
    ],
    [isGrid],
  );

  return (
    <Stack
      sx={{
        flexDirection: "row",
        borderRadius: "6px",
        border: "1px solid #E8ECF0",
      }}
    >
      {tabs.map(({ icon, selected, type }, index) => (
        <Stack
          key={index}
          onClick={() => setColumnsType(type)}
          sx={{
            padding: "4px 14px",
            backgroundColor: selected ? "#E8ECF0" : "transparent",
            cursor: selected ? "auto" : "pointer",
          }}
        >
          {icon}
        </Stack>
      ))}
    </Stack>
  );
};
